// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__rlI86","wave":"styles_wave__JXz6U"};